import React from "react";

/**
 * Form input component for sign in page
 */
const SignInFormInput = React.memo(
  ({
    name,
    type,
    placeholder,
    value,
    onChange,
    error,
    showToggle = false,
    onToggleShow = null,
    disabled = false,
  }) => (
    <div className="space-y-2">
      <div className="relative">
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`
          w-full px-4 py-3 rounded-2xl bg-gray-800/50 backdrop-blur border
          ${
            error
              ? "border-red-500/50 focus:border-red-400"
              : "border-gray-600/50 focus:border-violet-400/50"
          }
          text-white placeholder-gray-400
          focus:outline-none focus:ring-2 focus:ring-violet-400/20
          transition-all duration-200
          ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        `}
          disabled={disabled}
        />
        {showToggle && (
          <button
            type="button"
            onClick={onToggleShow}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white transition-colors duration-200"
            disabled={disabled}
            title={type === "password" ? "Show password" : "Hide password"}
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {type === "password" ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              ) : (
                <>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                  />
                </>
              )}
            </svg>
          </button>
        )}
      </div>
      {error && <p className="text-sm text-red-400 pl-1">{error}</p>}
    </div>
  ),
);

SignInFormInput.displayName = "SignInFormInput";

export default SignInFormInput;
